import React from 'react';
import { SvgIcon } from './svg-icon';

export const HamburgerSmall = props => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M4 9H20V10.5H4V9ZM4 13H14V14.5H4V13Z" />
  </SvgIcon>
);
